import { useState } from "react";
import { ClientPolicyMappingEnum } from "../../enum/normalization-mapping.enum.ts";
import DataGrid from "./DataGrid/DataGrid.tsx";
import { PolicyDetails } from "../PolicyDetails/PolicyDetails.tsx";

const ClientPoliciesDataGrid = ({ clientPoliciesList, isLoading }) => {
  const [selectedPolicyId, setSelectedPolicyId] = useState<string | null>(null);

  const handleRowClick = ({ data }) => {
    setSelectedPolicyId(data[ClientPolicyMappingEnum.POL_ID]);
  };

  const columns = [
    {
      name: ClientPolicyMappingEnum.POL_NUM,
      header: "№ полица",
      minWidth: 150,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.INS_COMP,
      header: "ЗК",
      minWidth: 50,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.POL_TYPE,
      header: "Тип",
      minWidth: 40,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.DIV_NAME,
      header: "Офис",
      minWidth: 40,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.SUM_POL,
      header: "Сума",
      minWidth: 40,
      type: "number",
    },
    {
      name: ClientPolicyMappingEnum.DATE_B,
      header: "От",
      minWidth: 55,
      type: "date",
    },
    {
      name: ClientPolicyMappingEnum.DATE_E,
      header: "До",
      minWidth: 55,
      type: "date",
    },
    {
      name: ClientPolicyMappingEnum.NAME_INS,
      header: "Клиент",
      minWidth: 80,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.TEL_INS,
      header: "Тел.",
      minWidth: 60,
      type: "string",
    },
    {
      name: ClientPolicyMappingEnum.REG_NO,
      header: "ДКН",
      minWidth: 60,
      type: "string",
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        dataSource={clientPoliciesList}
        isLoading={isLoading}
        gridTitle="Полици на клиента"
        idProperty={ClientPolicyMappingEnum.POL_ID}
        csvFilename="client_policies.csv"
        onRowClick={handleRowClick}
        editable={false}
      />
      {selectedPolicyId && <PolicyDetails policyId={selectedPolicyId} />}
    </>
  );
};

export default ClientPoliciesDataGrid;
